function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.508 5A6.515 6.515 0 009 11.508c0 1.68 2.226 5.867 3.629 8.112.514.89 1.893 3.247 2.329 3.838.101.135.303.219.529.219l.002.001c.229 0 .435-.086.538-.223.44-.593 1.685-2.718 2.128-3.487 1.505-2.401 3.862-6.783 3.862-8.46A6.516 6.516 0 0015.508 5zm-.02 20.678l-.004-.001c-.86-.001-1.658-.386-2.133-1.031-.584-.788-2.248-3.67-2.436-3.997C10.53 20.036 7 14.307 7 11.508 7 6.817 10.817 3 15.508 3c4.691 0 8.509 3.817 8.509 8.508 0 2.799-3.724 8.814-4.149 9.491-.149.261-1.647 2.855-2.237 3.649-.48.645-1.28 1.03-2.143 1.03zM15.5 9c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zm0 6c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4zm2.562 14h-5.124c-.519 0-.938-.448-.938-1s.42-1 .938-1h5.124c.519 0 .938.448.938 1s-.42 1-.938 1z",
  fill: "#000",
  fillRule: "evenodd"
});

function SvgIcMarkers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _ref);
}

export default SvgIcMarkers;